import { Base } from "../core/base.model";
import { Perfil } from "../security/perfil.model";
import { Persona } from "../security/persona.model";
import { Usuario } from "../security/usuario.model";

export class Puesto extends Base{
    id:number;
	id_area:number;
    puesto:string;
	estatus:string;
	imgEstatus:string;

}